import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { CheckCircleFilledIcon, CloseCircleFilledIcon } from 'tdesign-icons-react';
import { Drawer, Link, Table, Tooltip } from 'tdesign-react';
import { sortBy } from 'lodash';
import useTable from '@/hooks/useTable';
import { fetchUnhealthResultDetail } from '@/slices/clusterSlice';
import DiffDialog from './DiffDialog';

function ResultTable({ visible, handleClose, excuteResultList, fetchUnhealthResultDetail }) {
  const [diffVisible, setDiffVisible] = useState(false);

  const columns = [
    {
      colKey: 'metricsMode',
      title: '检查模块',
      width: 200,
      cell: ({ row }) => (
        <Line>
          <Left>{row.metricsMode}</Left>
          {row.health ? (
            <CheckCircleFilledIcon color='#10B880' />
          ) : (
            <Tooltip content='查看' theme='light'>
              <Link hover='color' theme='danger' onClick={() => showDiff(row)}>
                <CloseCircleFilledIcon color='#ee4444' />
              </Link>
            </Tooltip>
          )}
        </Line>
      ),
    },
    {
      colKey: 'metricsName',
      title: '检查项',
      width: 300,
    },
    {
      colKey: 'metricsDescription',
      title: '说明',
      width: 280,
    },
    {
      colKey: 'updateTime',
      title: '检查时间',
      cell: ({ row }) => dayjs(row.updateTime).format('YYYY-MM-DD HH:mm:ss'),
      width: 150,
    },
  ];

  const { config, setData } = useTable({
    columns,
  });

  useEffect(() => {
    setData(sortBy(excuteResultList, 'health'));
  }, [excuteResultList, setData]);

  const diffClose = () => {
    setDiffVisible(false);
  };

  const showDiff = (row) => {
    setDiffVisible(true);
    fetchUnhealthResultDetail({
      clusterName: row.clusterName,
      metricsName: row.metricsName,
      metricsMode: row.metricsMode,
    });
  };

  return (
    <Drawer
      header='健康状态详情'
      size='70%'
      footer={null}
      onOverlayClick={handleClose}
      onClose={handleClose}
      placement='right'
      visible={visible}
    >
      <Table {...config} rowKey='metricsName' />
      <DiffDialog visible={diffVisible} handleClose={diffClose} />
    </Drawer>
  );
}

export default connect(
  (state) => ({
    excuteResultList: state.cluster.excuteResultList,
  }),
  {
    fetchUnhealthResultDetail,
  },
)(ResultTable);

const Line = styled.div`
  display: flex;
  gap: 4px;
  align-items: flex-start;
  & > .t-link,
  & > .t-icon {
    margin-top: 4px;
  }
`;

const Left = styled.div`
  width: auto;
  word-break: break-all;
`;
